import React, { useEffect } from 'react';
import ChartsCard from '../chartsCard/chartsCard';
import { HeatMap } from 'common';
import { useState } from 'react';
import {
  formatDayHoursHeatmap,
  getJobTalentCountsByDaysHours,
} from 'controllers/dashboard/getJobTalentCountsByDaysHours';
import DayWiseApplicationEmpty from './dayWiseApplicationEmpty';

const DayWiseApplication = ({ jobId }) => {
  const [loading, setLoading] = useState(false);
  const [selectedDuration, setSelectedDuration] = useState(30);
  const [chartData, setChartData] = useState([]);
  const labelsX = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
  const labelsY = [
    '12 am',
    '1 am',
    '2 am',
    '3 am',
    '4 am',
    '5 am',
    '6 am',
    '7 am',
    '8 am',
    '9 am',
    '10 am',
    '11 am',
    '12 pm',
    '1 pm',
    '2 pm',
    '3 pm',
    '4 pm',
    '5 pm',
    '6 pm',
    '7 pm',
    '8 pm',
    '9 pm',
    '10 pm',
    '11 pm',
  ];

  const onChangeSelectedValue = (e) => {
    setSelectedDuration(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const response = await getJobTalentCountsByDaysHours(
        jobId,
        selectedDuration,
        ['Applied', 'Shortlisted', 'Interview', 'Offered', 'Hired', 'Rejected']
      );
      const data = formatDayHoursHeatmap(response);
      setChartData(data);
      setLoading(false);
    };

    fetchData();
  }, [selectedDuration, jobId]);

  const options = [
    {
      value: 7,
      label: '7 days',
    },
    {
      value: 15,
      label: '15 days',
    },
    {
      value: 30,
      label: '1 month',
    },
    {
      value: 60,
      label: '2 months',
    },
    {
      value: 1000,
      label: '3 years',
    },
  ];

  return (
    <ChartsCard
      title={'Day wise application'}
      spaceRight
      options={options}
      selectedOption={selectedDuration}
      onChangeSelectedValue={onChangeSelectedValue}
    >
      <DayWiseApplicationEmpty
        isEmpty={(!chartData || !chartData.length) && !loading}
      />

      {chartData && chartData.length && !loading ? (
        <HeatMap data={chartData} labelsX={labelsX} labelsY={labelsY} />
      ) : null}
    </ChartsCard>
  );
};

export default DayWiseApplication;
